import request from '@/utils/request'

// 类型表

let CategoryApi = {

    /*列表*/
    getList(data, errorback) {
        return request._post('/shop/study.category/index', data, errorback);
    },

    /*添加*/
    add(data, errorback) {
        return request._post('/shop/study.category/add', data, errorback);
    },

    /*删除*/
    del(data, errorback) {
        return request._post('/shop/study.category/del', data, errorback);
    },

    /*编辑*/
    edit(data, errorback) {
        return request._post('/shop/study.category/edit', data, errorback);
    },

    /*状态*/
    status(data, errorback) {
      return request._post('/shop/study.category/status', data, errorback);
    },

    /*批量*/
    batch(data, errorback) {
        return request._post('/shop/study.category/batch', data, errorback);
    },

    /*批量*/
    add_question(data, errorback) {
        return request._post('/shop/study.category/add_question', data, errorback);
    },

    /*排序*/
    saveSort(data, errorback) {
        return request._post('/shop/study.category/saveSort', data, errorback);
    },

    /*自定义ids*/
    getQsIds(data, errorback) {
        return request._post('/shop/study.category/getQsIds', data, errorback);
    },

    /*取学校ids*/
    getSchoolIds(data, errorback) {
        return request._post('/shop/study.category/getSchoolIds', data, errorback);
    },

    /*绑定学校*/
    bindSchool(data, errorback) {
        return request._post('/shop/study.category/bindSchool', data, errorback);
    },
}

export default CategoryApi;



// WEBPACK FOOTER //
// ./src/api/study/category.js